import React from 'react';
import Theme from '../../../styles/models/theme';
import AppStoreLogo from '../../../assets/logos/appStore.svg';
import GooglePlayLogo from '../../../assets/logos/googlePlay.svg';
import {APP_STORE, GOOGLE_PLAY_STORE} from '../../../utils/constants';
import {Container, Icon} from './styles';
import GradientLogo from '../../atoms/GradientLogo';

interface Props {
  name: string;
  className?: any;
}

const StoreButton: React.FC<Props> = ({name, className}) => {
  const getIcon = () => {
    switch (name) {
      case APP_STORE:
        return AppStoreLogo;
      case GOOGLE_PLAY_STORE:
        return GooglePlayLogo;
      default:
        break;
    }
  };

  const storeIcon = getIcon();

  const handleClick = () => {
    let url;
    switch (name) {
      case APP_STORE:
        url = 'https://www.google.com'; // Cambiar
        break;
      case GOOGLE_PLAY_STORE:
        url = 'https://www.youtube.com'; // Cambiar
        break;
      default:
        break;
    }
    const win = window.open(url, '_blank');
    win?.focus();
  };

  return (
    <Container className={className} onClick={handleClick}>
      <GradientLogo src={storeIcon} height={43} width={120} />
    </Container>
  );
};

export default StoreButton;
